import { render, staticRenderFns } from "./DuplicateWarningModal.vue?vue&type=template&id=2bd94cf6&scoped=true&"
import script from "./DuplicateWarningModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateWarningModal.vue?vue&type=style&index=0&id=2bd94cf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd94cf6",
  null
  
)

export default component.exports